<template>
  <div>
    <AlertModal
      v-if="showAlert"
      :alert-text="alertText"
      :on-click-ok="onClickOk"
    />
    <div class="crash-reports">
      <div class="header-view">
        <h2>Available Crashes</h2>
        <div v-if="!noDataText" class="form-outline">
          <input
            v-model="userID"
            type="text"
            class="input-text"
            placeholder="Search User ID"
          />
          <i @click="searchUserID" id="search-icon" class="fas fa-search"></i>
        </div>
      </div>
      <div class="table-view">
        <table ref="table" class="sktable sktable--sticky" width="100%">
          <thead>
            <tr>
              <th v-for="(column, index) in listingData.columns" :key="index">
                {{ column }}
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index">
              <td
                v-for="(column, indexColumn) in listingData.columnsItems"
                :key="indexColumn"
                style="white-space: pre-line;"
              >
                {{ getColumn(item, column) ? getColumn(item, column) : 'NA' }}
              </td>

              <div class="table-row-view">
                <router-link
                  :to="`/crash-reporting/${accountId}/apps/${appId}/report/${item.id}`"
                >
                  View</router-link
                >
              </div>
            </tr>
          </tbody>
        </table>
        <div
          class="loadingText"
          v-if="loadingText && !noDataText"
          @click="loadingText !== 'Loading...' ? scrollToTop() : null"
        >
          {{ loadingText }}
        </div>
        <div class="noDataText" v-if="!isCrashReportingEnabled">
          The crash detection solution has not been activated for this app id.
          You can find more information on the
          <a href="https://sentiance.com/blog/">Sentiance blog</a>, or if you
          wish to learn more about this feature please contact
          sales@sentiance.com.
        </div>
        <div
          align="center"
          class="noDataText"
          v-if="isCrashReportingEnabled && noDataText"
        >
          There are no reports found for this app id.
        </div>
      </div>
    </div>
    <div>
      <div class="bottom-container">
        <div class="bottom-header">
          See something missing? Request a manual report
        </div>
        <div class="date-picker-content">
          <div>
            <div>User ID*</div>
            <input
              type="text"
              id="code"
              name="code"
              autocomplete="off"
              placeHolder="Enter here"
              v-model="inputUserId"
            />
          </div>
          <div>
            <div>Select Date and Time*</div>
            <input class="date-picker" type="dateTime-local" v-model="date" />
          </div>
          <div @click="onRequest" class="request-button">Request</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from 'sentiance.commons.sentikit';
import { listingData } from './data';
import moment from 'moment';
import AlertModal from './AlertModal.vue';

export default {
  name: 'CrashReports',
  data: function () {
    return {
      data: [],
      listingData: [],
      accountId: '',
      appId: '',
      paginationToken: '',
      limit: 8,
      loading: false,
      loadingText: '',
      loadFirstTime: false,
      userID: '',
      noDataText: '',
      isCrashReportingEnabled: false,
      date: '',
      time: '',
      inputUserId: '',
      showAlert: false,
      alertText: '',
    };
  },
  components: {
    AlertModal,
  },
  mounted() {
    this.loadingText = 'Loading...';
    this.listingData = listingData;
    this.accountId = this.$route.params.account_id;
    this.appId = this.$route.params.app_id;
    window.addEventListener('scroll', this.onScroll, true);
    this.loadFirstTime = true;
    this.onLoadReports();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
  },
  methods: {
    async getToken() {
      return await getAccessToken();
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.onLoadReports();
      }
    },
    scrollToTop() {
      document.body.scrollTo = 0;
      document.documentElement.scrollTop = 0;
      this.$refs.table.scrollIntoView();
    },
    onLoadReports() {
      if ((this.paginationToken || this.loadFirstTime) && !this.loading) {
        this.loadFirstTime = false;
        this.loading = true;
        this.loadingText = '';
        this.$api.get(this.getReportApi()).then((r) => {
          this.getResponse(r, this.setLoadingText(r), true);
        });
      } else {
        this.loadingText = 'end of the list... Scroll to top';
      }
    },
    setLoadingText(r) {
      if (r.body.reports.length === 0) {
        this.noDataText = true;
      } else if (r.body.pagination_token) {
        return 'Loading...';
      } else {
        return '';
      }
    },
    searchUserID() {
      this.loading = true;
      this.loadingText = 'Loading...';
      if (this.paginationToken !== '') {
        this.$api
          .get(this.getReportApi(this.userID, this.paginationToken))
          .then((r) => {
            this.getResponse(
              r,
              this.data.length === 0 ? 'No data available' : '',
              false
            );
          });
      } else {
        this.$api.get(this.getReportApi(this.userID)).then((r) => {
          this.getResponse(
            r,
            this.data.length === 0 ? 'No data available' : '',
            false
          );
        });
      }
    },
    getReportApi(userID, paginationToken) {
      if (userID && paginationToken) {
        return `accounts/${this.accountId}/apps/${this.appId}/crash_reports?user_id=${this.userID}&limit=${this.limit}&pagination_token=${this.paginationToken}`;
      } else if (userID) {
        return `accounts/${this.accountId}/apps/${this.appId}/crash_reports?user_id=${this.userID}&limit=${this.limit}`;
      } else {
        return `accounts/${this.accountId}/apps/${this.appId}/crash_reports?limit=${this.limit}&pagination_token=${this.paginationToken}`;
      }
    },
    getResponse(r, text, reports) {
      let response = r.body.reports;
      this.data = reports ? [...this.data, ...response] : response;
      this.paginationToken = r.body.pagination_token;
      this.loading = false;
      this.loadingText = text;
      this.isCrashReportingEnabled = r.body.is_crash_reporting_enabled;
    },
    click(item) {
      this.$router.push({
        name: 'CrashReportingIndividualReport',
        params: {
          account_id: this.accountId,
          app_id: this.appId,
          report_id: item.id,
        },
      });
    },
    currentHour() {
      return new Date().getHours() + 'hr';
    },
    currentMinute() {
      return new Date().getMinutes() + 'min';
    },
    getColumn(item, column) {
      if (column === 'user_id') {
        return (
          'Sentiance: ' +
          item[column] +
          '\n' +
          'External: ' +
          item['external_id']
        );
      } else if (column === 'crash_timestamp') {
        let utc = moment.parseZone(item[column]).utcOffset();
        return (
          moment
            .utc(item[column])
            .utcOffset(utc)
            .format('ddd, DD MMM YYYY, HH:mm Z') + ' GMT'
        );
      } else {
        return item[column];
      }
    },
    onRequest() {
      this.$api
        .post(
          `accounts/${this.accountId}/apps/${this.appId}/crash_reports/inject-crash`,
          {
            approximate_crash_time: this.date,
            user_id: this.inputUserId,
          }
        )
        .then((r) => {
          this.showAlert = true;
          this.alertText =
            'Request submitted successfully. A report will be available soon.';
        })
        .catch((error) => {
          this.alertText = error.body.message;
          this.showAlert = true;
        });
    },
    onClickOk() {
      this.showAlert = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-view {
  max-height: 450px;
  display: block;
  overflow: scroll;
  margin-left: 16px;
  margin-right: 16px;
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.1);
}

.header-view {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.no-data-text {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
}

.table-row-view {
  margin-top: 28px;
  margin-left: 28px;
}

a {
  color: #4a71d8;
  text-decoration: none;
}

.loadingText {
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 36px;
  padding-bottom: 36px;
  font-weight: 600;
}

.noDataText {
  width: 100%;
  align-content: center;
  padding: 36px;
  font-weight: 600;
}
.input-text {
  border-color: transparent;
  margin-left: auto;
}

.form-outline {
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  margin-left: auto;
}

#search-icon {
  margin-right: 12px;
}

.bottom-container {
  margin-top: 24px;
  margin-left: 16px;
  margin-right: 16px;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.1);
}

.bottom-header {
  font-weight: bold;
  size: 24px;
  text-align: center;
}

.date-picker-content {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 16px;
}

.date-picker {
  height: 48px;
}

.request-button {
  background-color: #3e66fb;
  color: white;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 54px;
  padding-right: 54px;
  height: 48px;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-end;
}
</style>
